export default {
  "betReport.title": "投注报表",
  "betReport.thead.userno": "用户编号",
  "betReport.thead.email": "邮箱",
  "betReport.thead.nickname": "昵称",
  "betReport.thead.createTime": "注册时间",
  "betReport.thead.totalBetAmount": "总投注金额",
  "betReport.thead.totalWinAmount": "总中奖金额",
  "betReport.thead.totalGainAmount": "总输赢金额",
  "betReport.thead.winRatio": "盈利率",
  "betReport.thead.totalDepositAmount": "总存款金额",
  "betReport.thead.totalWithdrawAmount": "总提款金额",
  "betReport.thead.vipLevel": "VIP等级",
  "betReport.tooltip.copyUserNo": "复制用户编号: {text}",
  "betReport.copy.success": "复制成功!",
  "depositRecord.tooltip.showUserDetails": "显示用户详情",
};